module.exports = __webpack_public_path__ + "static/media/notification_bell.cb9dfe0f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/new_menu_icons/notification_bell.svg
// module id = 2711
// module chunks = 0